//Reference: EN116

import { Mappeable } from './mappeable.model';
import moment from 'moment';
import * as _ from 'lodash';


export class RelevantAspect extends Mappeable {

    idRelevantAspectPk: any;
    organizationalStructure: any;
    entitiesList: string;
    dateCreation: string;
    txtName: string;
    txtStandardName: string;
    typeRelevantAspect: any;
    documents: string;
    //comments: string;
    txtLegalNews: string;
    txtColab: string;
    txtAuditExt: string;
    txtRegulators: string;
    txtFrauds: string;
    txtOthers: string;
    txtFormation: string;
    nmrExercise: Number;

    constructor(o) {
        super(o);
    }

    public mapToBack() {
        return {
            idRelevantAspectPk: this.idRelevantAspectPk,
            typeRelevantAspect: this.typeRelevantAspect,
            entitiesList: this.entitiesList,
            organizationalStructure: this.organizationalStructure,
            documents: this.documents,
            txtName: this.txtName,
            txtStandardName: this.txtStandardName,
            dateCreation: moment(this.dateCreation).format('YYYY-MM-DD') || moment().format('YYYY-MM-DD'),
            //comments: this.comments
            txtLegalNews: this.txtLegalNews,
            txtColab: this.txtColab,
            txtAuditExt: this.txtAuditExt,
            txtRegulators: this.txtRegulators,
            txtFrauds: this.txtFrauds,
            txtOthers: this.txtOthers,
            nmrExercise: this.nmrExercise,
            txtFormation: this.txtFormation
        }
    }

}
